import { Link } from 'react-router'

import {
    Button,
    Card,
    IconArrowRight,
    IconBox,
    IconMessageChatSquare,
    PageHeader
} from '@/components'
import { AuthLayout } from '@/containers'
import { BatteryEligibilityTypeEnum } from '@/enums'
import { useAuth } from '@/hooks'

const TRAINING_PADLET_LINK = 'https://padlet.com/marketing1265/solar-insure-training-collateral-aqym3mijcx73bhf8'
const MEDIA_KIT_PADLET_LINK = 'https://padlet.com/solarinsuremarketing/certified-provider-media-kit-tftb11hrpegqmotl'

const SupportIndex = () => {
    const auth = useAuth()
    const shouldUseTrainingPadlet = auth.user?.role.isAdminOrStaff ||
        auth?.user?.company?.battery_eligibility?.key === BatteryEligibilityTypeEnum.BATTERY_30_YEAR

    const items = [{
        id: 1,
        title: 'Marketing Resources via Padlet',
        description: 'Everything you need to explore, download & share marketing materials',
        path: shouldUseTrainingPadlet ? TRAINING_PADLET_LINK : MEDIA_KIT_PADLET_LINK,
        icon: <IconBox className="stroke-primary-700"/>,
        ctaText: 'Learn More'
    },
    {
        id: 2,
        title: 'Contact Support',
        description: 'Can’t find what you’re looking for? Contact our support team for help.',
        path: '/support/contact',
        icon: <IconMessageChatSquare className="stroke-primary-700"/>,
        ctaText: 'Get In Touch'
    }]

    return <AuthLayout heading={<PageHeader title="Support"/>}>
        <Card className="mt-16">
            <h1 className="font-display text-2xl font-medium text-gray-900 mb-1">Need help?</h1>
            <h3 className="font-body text-lg text-gray-500">
                Whether you’re looking for resources or require hands-on help, we’re here for you.
            </h3>
            <hr className="mt-6 mb-10 border-gray-200"/>
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8">
                {items.map(item =>
                    <Link
                        to={item.path}
                        key={item.id}
                        className="shadow-md bg-gray-50 flex flex-col justify-center items-start px-4 pt-5 pb-9 border border-gray-200 rounded-xl relative"
                    >
                        <div className="w-12 h-12 rounded-full bg-primary-50 flex justify-center items-center mb-8">
                            <div className="w-9 h-9 rounded-full bg-primary-100 flex justify-center items-center">
                                {item.icon}
                            </div>
                        </div>
                        <h2 className="text-lg flex items-center leading-7 font-body">
                            {item.title}
                        </h2>
                        <p className="text-gray-500 mt-2 font-body">{item.description}</p>
                        <Button className="mt-5 leading-6" design="btn-link" size="btn-lg">
                            {item.ctaText} <IconArrowRight className="stroke-primary-700 ml-2"/>
                        </Button>
                    </Link>)}
            </div>
        </Card>
    </AuthLayout>
}

export default SupportIndex
